/**
 * 解析菜单 url 中的 buttonData（与 PermissionMethodToolbar / PermissionMethodRow 一致）
 * 格式：名称:事件名:排序:样式:分组id,名称:事件名:...
 * 后端偶发缺段时也尽量识别「事件名」
 */

function getQueryString (url, name) {
  if (!url) return null
  try {
    const search = decodeURIComponent(String(url))
    const index = search.indexOf('?')
    if (index === -1) return null
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    const r = search.substr(index + 1).match(reg)
    if (r != null) return unescape(r[2])
  } catch (e) {
    // url 非法编码时降级直接取原始 query
    const index = String(url).indexOf('?')
    if (index === -1) return null
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    const r = String(url).substr(index + 1).match(reg)
    if (r != null) return unescape(r[2])
  }
  return null
}

export function getButtonData (url) {
  return getQueryString(url, 'buttonData') || ''
}

/**
 * @param {string} url 菜单完整 url（含 buttonData）
 * @param {string} [id] 分组 id（对应「激活状态」，如 toolbar / rowtoolbar / home），不传则不过滤
 */
export function parsePermissionButtons (url, id) {
  const buttonData = getButtonData(url)
  if (!buttonData) return []
  const list = []
  const array = buttonData.split(',')
  for (let i = 0; i < array.length; i++) {
    const element = (array[i] || '').trim()
    if (!element) continue
    const buttons = element.split(':')
    // 至少要有「名称:事件名」
    if (buttons.length < 2) continue
    const groupId = buttons.length >= 5 ? buttons[4] : (buttons[3] || '')
    if (id != null && id !== '' && groupId && groupId != id) continue
    list.push({
      value: buttons[0],
      onclick: buttons[1],
      alt: buttons[2] || '',
      type: buttons[3] || '',
      id: groupId
    })
  }
  return list
}

/**
 * 是否拥有某个权限方法（出现在 buttonData 中即表示角色已勾选）
 */
export function hasPermissionMethod (url, methodScriptName, id) {
  if (!methodScriptName) return false
  const list = parsePermissionButtons(url, id)
  if (list.some(item => item.onclick === methodScriptName)) return true
  // 兜底：整段 buttonData 里直接包含事件名（兼容异常拼接）
  const raw = getButtonData(url)
  if (!raw) return false
  return raw.split(',').some(item => {
    const parts = item.split(':')
    return parts.indexOf(methodScriptName) !== -1
  })
}

/**
 * 从菜单树中查找包含指定路径的完整 url（含 buttonData）
 */
export function findMenuUrlByPath (menuGroups, pathKeyword) {
  const found = findMenuByPath(menuGroups, pathKeyword)
  return found ? found.url : ''
}

/**
 * 从菜单树中查找包含指定路径的菜单项（url + 标题）
 */
export function findMenuByPath (menuGroups, pathKeyword) {
  if (!menuGroups || !pathKeyword) return null
  const walk = (nodes) => {
    if (!nodes || !nodes.length) return null
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i]
      const url = node.url || node.moduleUrl || ''
      if (url && url.indexOf(pathKeyword) !== -1) {
        return {
          url,
          title: node.moduleName || node.permissionname || node.name || ''
        }
      }
      const children = node.children || []
      const found = walk(children)
      if (found) return found
    }
    return null
  }
  return walk(menuGroups)
}
